import { memo, useMemo } from "react";
import { Alert, Typography } from "antd";
import { useLocation, Link } from "react-router-dom";

const regionsUrl = {
  usCentral: "us-central.unstract.com",
  euWest: "eu-west.unstract.com",
};

const usHosts = [
  "frontend.unstract.localhost",
  "globe.unstract.com",
  regionsUrl.usCentral,
];
const euHosts = [regionsUrl.euWest];

const SwitchRegion = memo(function SwitchRegion() {
  const location = useLocation();
  const host = window.location.host;

  // Determine current region
  const currentRegion = useMemo(() => {
    if (usHosts.includes(host)) return "usCentral";
    if (euHosts.includes(host)) return "euWest";
    return null;
  }, [host]);

  const { introText, signUpLink } = useMemo(() => {
    const filteredPath = location.search
      ? `${location.pathname}${location.search}`
      : location.pathname;

    // Construct region-specific sign-up URLs
    const signUpUS = `https://${regionsUrl.usCentral}${filteredPath}`;
    const signUpEU = `https://${regionsUrl.euWest}${filteredPath}`;

    let introText = "";
    let signUpLink = "";

    if (currentRegion === "usCentral") {
      introText =
        "You are about to sign up for the US region. Looking for the EU region?";
      signUpLink = signUpEU;
    } else if (currentRegion === "euWest") {
      introText =
        "You are about to sign up for the EU region. Looking for the US region?";
      signUpLink = signUpUS;
    }

    return { introText, signUpLink };
  }, [location.pathname, location.search, currentRegion]);

  if (!currentRegion) {
    return null;
  }

  return (
    <Alert
      message={
        <Typography className="text-align-center">
          {introText}{" "}
          <Link to={signUpLink} reloadDocument>
            Sign up here
          </Link>
        </Typography>
      }
    />
  );
});

export { SwitchRegion };
